import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import { logoFullWhite, logoIconWhite } from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import { payService } from "api";
import { columns, getTodayString } from "./ModalPrint.config";
import { useAppSelector } from "redux/hooks";
import moment from "moment";
import "./ModalPrint.scss";
import { analysisService } from "api";
import { FORMAT_TIME } from "types/enums";
import { TableInputAdd } from "components/common";
import BoxBHYT from "pages/Pay/PayTab/ModalPrintPTT/BoxBHYT/BoxBHYT";
import {
  convertIosStringToDateDayjs,
  formatDateToString,
  getDateStringLocale,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import ContentPrint from "./ContentPrint";

const { Text } = Typography;

const ModalPrint = (props) => {
  const { isShowModal, handleOk, handleCancel, listId } = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [ketLuan, setKetLuan] = useState<any>(null);
  const [benhPhu, setBenhPhu] = useState<any>(null);
  const [data, setData] = useState([]);
  const [nuoctieu, setNuoctieu] = useState([]);
  console.log("🚀 ~ ModalPrint ~ nuoctieu:", nuoctieu);
  const idXetNghiem = useAppSelector((state) => state.reduxCommon.id2);
  const idBh = useAppSelector((state) => state.common.idReceiptPrint);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  // console.log('list id xn',listId);

  useEffect(() => {
    if (!listId || !listId.length) {
      getData();
    } else {
      getDataByListId();
    }
  }, [isShowModal, idXetNghiem, listId]);

  const getData = async () => {
    try {
      let response = await analysisService
        .getDataPrintXN(idXetNghiem)
        .then((res) => {
          setThongTinIn(res.data);
          const newData = res.data.nhomCDXNDtos;
          const dataTable = newData.map((item) => {
            return {
              key: item.tenNhomXetNghiem,
              tenXetNghiem: item.tenNhomXetNghiem,
              children: item.cdxnDtos.map((e, idx) => {
                if (e.tenXetNghiem == e.ketQua[0]?.tenChiSoXetNghiem) {
                  e.tenXetNghiem = "";
                }
                return {
                  key: `${e.tenXetNghiem}${e.id}${idx}`,
                  id: e.id,
                  tenXetNghiem: e.tenXetNghiem,
                  children: e.ketQua.map((i) => {
                    return {
                      ...i,
                      giaTri: checkValue(
                        i.giaTri,
                        i.giaTriBinhThuong,
                        i.tenChiSoXetNghiem
                      ),
                      key: `${i.tenChiSoXetNghiem}${i.id}${
                        Math.floor(Math.random() * (9999999 - 1 + 1)) + 1
                      }`,
                      tenXetNghiem: i.tenChiSoXetNghiem,
                      isExceed: checkValueExceed(i.giaTri, i.giaTriBinhThuong),
                    };
                  }),
                };
              }),
            };
          });
          setData(dataTable.filter((el) => el.tenXetNghiem != "Nước tiểu"));
          setNuoctieu(dataTable.filter((el) => el.tenXetNghiem == "Nước tiểu"));
          setKetLuan(res.data.ketLuanDto?.chiTietKetLuans);
          setBenhPhu(res.data.ketLuanDto?.chiTietBenhPhuDtos);
        });
    } catch (error) {
      console.log("error", error);
      setThongTinIn(null);
      setData([]);
    }
  };
  const checkValue = (value, checkValue, name) => {
    const parsedValue = parseFloat(value);
    if (checkValue !== null) {
      if (checkValue.indexOf("-") !== -1) {
        const mangGiaTri = checkValue.split("-");
        const giaTri1 = parseFloat(mangGiaTri[0]);
        const giaTri2 = parseFloat(mangGiaTri[1]);
        if (!isNaN(parsedValue)) {
          if (parsedValue < giaTri1) {
            return value + " (L)";
          } else if (parsedValue > giaTri2) {
            return value;
          } else {
            return value;
          }
        } else {
          return value;
        }
      } else {
        if (name == "UBG (UROBILINOGEN)" && value == null) {
          return "Normal";
        } else {
          return value;
        }
      }
    } else {
      return value;
    }
  };
  const checkValueExceed = (value, checkValue) => {
    const parsedValue = parseFloat(value);
    if (checkValue !== null) {
      if (checkValue.indexOf("-") !== -1) {
        const mangGiaTri = checkValue.split("-");
        const giaTri1 = parseFloat(mangGiaTri[0]);
        const giaTri2 = parseFloat(mangGiaTri[1]);
        if (!isNaN(parsedValue)) {
          if (parsedValue < giaTri1) {
            return true;
          } else if (parsedValue > giaTri2) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };

  const getDataByListId = async () => {
    try {
      let response = await analysisService
        .getDataPrintXNByListId(listId)
        .then((res) => {
          setThongTinIn(res.data);
          const newData = res.data.nhomCDXNDtos;
          const dataTable = newData.map((item) => {
            return {
              key: item.tenNhomXetNghiem,
              tenXetNghiem: item.tenNhomXetNghiem,
              children: item.cdxnDtos?.map((e, idx) => {
                if (e.tenXetNghiem == e.ketQua[0]?.tenChiSoXetNghiem) {
                  e.tenXetNghiem = "";
                }
                return {
                  key: `${e.tenXetNghiem}${e.id}${idx}`,
                  id: e.id,
                  tenXetNghiem: e.tenXetNghiem,
                  children: e.ketQua?.map((i) => {
                    return {
                      ...i,
                      giaTri: checkValue(
                        i.giaTri,
                        i.giaTriBinhThuong,
                        i.tenChiSoXetNghiem
                      ),
                      key: `${i.tenChiSoXetNghiem}${i.id}${
                        Math.floor(Math.random() * (9999999 - 1 + 1)) + 1
                      }`,
                      tenXetNghiem: i.tenChiSoXetNghiem,
                      isExceed: checkValueExceed(i.giaTri, i.giaTriBinhThuong),
                    };
                  }),
                };
              }),
            };
          });

          setData(dataTable.filter((el) => el.tenXetNghiem != "Nước tiểu"));
          setNuoctieu(dataTable.filter((el) => el.tenXetNghiem == "Nước tiểu"));
          setKetLuan(res.data.ketLuanDto?.chiTietKetLuans);
          setBenhPhu(res.data.ketLuanDto?.chiTietBenhPhuDtos);
        });
    } catch (error) {
      console.log("error", error);
      setThongTinIn(null);
      setData([]);
    }
  };

  const expandAllRows = () => {
    const keys = [];
    const expandKeys = (data) => {
      data?.forEach((item) => {
        keys.push(item.key);
        if (item.children) {
          expandKeys(item.children);
        }
      });
    };
    expandKeys(data);
    setExpandedRowKeys(keys);
  };

  useEffect(() => {
    expandAllRows();
  }, [isShowModal, idXetNghiem, data]);

  // const calculateSelectedRowsTotal = (dataIndex) => {
  //   let total = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     total += data[i][dataIndex] || 0;
  //   }
  //   return total;
  // };

  const onPrint = async () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("content");
    const headers = document.getElementsByTagName("thead");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;

      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        const footerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight);
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    // window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };

  return (
    <Row className="exam-reg-bill">
      <Modal
        wrapClassName="modal-custom-print-result-analysis"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={nuoctieu.length > 0 ? 1800 : 1000}
      >
        <div className="print-analysis-result">
          <div
            className="content-print-xet-nghiem"
            style={{
              padding: "20px 30px 30px 60px",
            }}
          >
            <Row gutter={30}>
              {data.length > 0 && (
                <Col span={nuoctieu.length > 0 ? 12 : 24}>
                  <div style={{ breakAfter: "page" }}>
                    <ContentPrint
                      data={data}
                      nuoctieu={nuoctieu}
                      thongTinIn={thongTinIn}
                    />
                  </div>
                </Col>
              )}
              {nuoctieu.length > 0 && (
                <Col span={12}>
                  <ContentPrint data={nuoctieu} thongTinIn={thongTinIn} />
                </Col>
              )}
            </Row>
          </div>
        </div>
        <div style={{ display: "none" }}>
          <div
            ref={printRef}
            className="content-print-xet-nghiem"
            style={{
              padding: "0px 30px 50px 60px",
            }}
          >
            <Row gutter={30}>
              {data.length > 0 && (
                <div style={{ breakAfter: "page" }}>
                  <ContentPrint
                    data={data}
                    thongTinIn={thongTinIn}
                    nuoctieu={nuoctieu}
                  />
                </div>
              )}
              {nuoctieu.length > 0 && (
                <ContentPrint data={nuoctieu} thongTinIn={thongTinIn} />
              )}
            </Row>
          </div>
        </div>
        <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              // pageStyle="@page { margin: 50px }"
              // onAfterPrint={handleCancel}
              bodyClass="print-analysis-result"
              // pageStyle="A4"
            />
          </Space>
        </Row>
      </Modal>
    </Row>
  );
};

export default ModalPrint;
